module.exports = __webpack_public_path__ + "assets/img/qrcode-douyin-5346a1d4.png";